import { ProductDetailsElement } from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext } from "react";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import {
  BrandKitContext,
  ProductBeingReviewedContext,
} from "../review-form-editor-contexts";

export const ReviewsProductDetails = memo(function ReviewsProductDetails({
  element,
}: {
  element: ProductDetailsElement;
}) {
  const brandKit = useContext(BrandKitContext);
  const product = useContext(ProductBeingReviewedContext);

  const fontFamily = brandKit.font.fontFamily;

  return (
    <Flex align="center" dir="column" style={{ fontFamily: fontFamily }}>
      <img
        alt="Product image"
        src={product.imageUrl}
        style={{ width: element.imageWidthPercentage + "%" }}
      />
      <Text fontSize="md" fontWeight="medium">
        {product.title}
      </Text>
      {product.purchaseDate && (
        <Text fontSize="sm" fontWeight="thin" textColor="tertiary">
          {`Purchased on ${product.purchaseDate.getMonth() + 1}/${product.purchaseDate.getDate()}/${product.purchaseDate.getFullYear()}`}
        </Text>
      )}
    </Flex>
  );
});

export const productDetailsInspector: InspectorConfig<ProductDetailsElement> = {
  sections: [
    {
      fields: [
        {
          widget: "number",
          label: "Image Width Percentage",
          path: "imageWidthPercentage",
          min: 0,
          max: 100,
        },
      ],
    },
  ],
};
